/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPost
 */
export interface ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPost {
    /**
     * 
     * @type {string}
     * @memberof ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPost
     */
    file: string;
}

/**
 * Check if a given object implements the ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPost interface.
 */
export function instanceOfControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPost(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "file" in value;

    return isInstance;
}

export function ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPostFromJSON(json: any): ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPost {
    return ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPostFromJSONTyped(json, false);
}

export function ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': json['file'],
    };
}

export function ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPostToJSON(value?: ControlBodyUploadResolutionEvidenceAsmEntityEntityIdResolutionsRequestIdPost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': value.file,
    };
}

